import { Component, Inject, Mixins } from 'vue-property-decorator';
import { mapActions } from 'vuex';
import { namespace } from 'vuex-class';
import ReviewsBlock from '@/components/parts/reviews';
import ReviewMixin from '@/pages/review-mixin';
import CardMixin from '../common';
import { ACTION_ADD, ACTION_FETCH, STORE_MODULE_NAME } from './const';
import createStoreModule from './store';
import { Review, Reviews, State as StateType, Statuses } from './types';

const { ERROR } = Statuses;
const actions = mapActions(STORE_MODULE_NAME, [ACTION_FETCH]);
const fetch = actions[ACTION_FETCH];
const Reviews = namespace(STORE_MODULE_NAME);
const User = namespace('user');

const isError = (value: any) => value === ERROR;

@Component({
  components: { ReviewsBlock },
  storeName: STORE_MODULE_NAME,
  storeRegister: createStoreModule,
})
export default class PageOrganizationCardReviews extends Mixins(CardMixin, ReviewMixin) {
  // Vuex
  @Reviews.Action(ACTION_ADD) add: (review: Review, immediately: boolean) => Promise<any>;
  // TODO: чекнуть что я сломаю если удалю этот код
  // @ts-ignore
  @Reviews.State('reviews') reviews: StateType['reviews'];
  @User.Getter('fio') fio: string;
  @User.Getter('isAuthorized') isAuthorized: boolean;
  @User.State('profile') profile: any;
  
  // Inject
  @Inject() $config: any;

  // Data
  reviewError: string = '';
  reviewPopup: boolean = false;

  // Computed
  get list() {
    return this.reviews || [];
  }

  get userData() {
    const { isAuthorized, fio } = this;
    if (isAuthorized) {
      const { email } = this.profile;
      return { email, fio };
    }
  }

  // AsyncData
  async asyncData({ store, route }: any): Promise<void> {
    const params = { organization_id: route.params.id }
    await fetch.call({ $store: store }, params);
  }

  // Methods
  async submitReview(review: Review) {
    const { $config, organization, reviews } = this;
    const data = { ...review, organization_id: organization.id };

    try {
      await this.add(data, $config.reviews.addImmediately);
      if (!$config.reviews.addImmediately) this.reviewPopup = true;
    } catch (error) {
      this.reviewError = error ? error.message : $config.errors.default;
    }
  }

  async loadReviews() {}
}



// WEBPACK FOOTER //
// ./src/pages/organizations/card/reviews/script.ts